import {
    SET_USERNAME,
    SET_YEAR,
    SET_TELEGRAM,
    SET_PHONE,
    SET_MEMBERSHIP,
    SET_EMAIL,
    SET_DISCORD,
    SET_ADMIN,
    LOGIN_PROFILE,
    LOGOUT_PROFILE,
    SET_CURRENT_CLASSES,
    SET_CAMPUS,
    SHOW_INFO_FORM,
    HIDE_INFO_FORM,
    SET_CURRENT_CLASSES_DATA
}from '../actions/types';



const initialState = {
   userName: null, 
   year: null, 
   telegram: null, 
   phone: null, 
   membership: "FT",
   email:"example@example.com",
   discord: null,
   isAdmin: false,
   currentClasses: null,
   campus: null,
   showInfoForm: false,
   currentClassesData: []

};

export default function(state = initialState, action){
    const { type, payload } = action;
   
    switch(type){
        case SET_USERNAME:
            return{
                ...state, 
                userName: payload
            }
        case SET_YEAR:
            return {
                ...state,
                year: payload
            };          
        case SET_TELEGRAM:
            return {
                ...state, 
                telegram: payload
            }
        case SET_PHONE:
            return {
                ...state,
                phone: payload
            };
        case SET_MEMBERSHIP:
            return {
                ...state, 
                membership: payload
            };

        case SET_EMAIL:
            return{
                ...state, 
                email: payload
            }
        case SET_DISCORD:
            return {
                ...state, 
                discord: payload
            };

        case SET_ADMIN:
            return {
                ...state, 
                isAdmin: payload
            };

        case SET_CURRENT_CLASSES:
            return {
                ...state,
                currentClasses: payload
            };

        case SET_CAMPUS:
            return {
                ...state,
                campus: payload
            };

        case SHOW_INFO_FORM:
            return {
                ...state,
                showInfoForm: true
            };

        case HIDE_INFO_FORM:
            return {
                ...state,
                showInfoForm: false
            };

        case SET_CURRENT_CLASSES_DATA:
            return {
                ...state,
                currentClassesData: payload
            };

        case LOGIN_PROFILE:
            return{
                ...state, 
                userName: payload.UserName,
                year: payload.year,
                telegram: payload.Telegram, 
                phone: payload.Phone, 
                membership: payload.Membership, 
                email: payload.Email, 
                discord: payload.Discord,
                isAdmin: payload.isAdmin || false,
                currentClasses: payload.CurrentClasses,
                campus: payload.campus
            }
        
        case LOGOUT_PROFILE:
            return{
                ...state, 
                userName: null,
                year: null,
                telegram: null, 
                phone:null, 
                membership: null, 
                email: null, 
                discord: null,
                isAdmin: false,
                currentClasses: null,
                campus: null,
                showInfoForm: false,
                currentClassesData: []
            }
        default:
            return state;
    }
}
